<div class="grid flex">
    <div class="flex" *ngFor="let news of newsItems$ | async">
        <riege-card class="card--news flex flex-grow-shrink-auto" [data]="news"></riege-card>
    </div>
</div>
